export const INVENTORY_LIST_REQUEST = 'INVENTORY_LIST_REQUEST'
export const INVENTORY_LIST_SUCCESS = 'INVENTORY_LIST_SUCCESS'
export const INVENTORY_LIST_FAIL = 'INVENTORY_LIST_FAIL'
export const INVENTORY_LIST_RESET = 'INVENTORY_LIST_RESET'

export const INVENTORY_ADD_REQUEST = 'INVENTORY_ADD_REQUEST'
export const INVENTORY_ADD_SUCCESS = 'INVENTORY_ADD_SUCCESS'
export const INVENTORY_ADD_FAIL = 'INVENTORY_ADD_FAIL'
export const INVENTORY_ADD_RESET = 'INVENTORY_ADD_RESET'

export const INVENTORY_DELETE_REQUEST = 'INVENTORY_DELETE_REQUEST'
export const INVENTORY_DELETE_SUCCESS = 'INVENTORY_DELETE_SUCCESS'
export const INVENTORY_DELETE_FAIL = 'INVENTORY_DELETE_FAIL'

export const INVENTORY_UPDATE_REQUEST = 'INVENTORY_UPDATE_REQUEST'
export const INVENTORY_UPDATE_SUCCESS = 'INVENTORY_UPDATE_SUCCESS'
export const INVENTORY_UPDATE_FAIL = 'INVENTORY_UPDATE_FAIL'
export const INVENTORY_UPDATE_RESET = 'INVENTORY_UPDATE_RESET'

export const INVENTORY_DETAILS_REQUEST = 'INVENTORY_DETAILS_REQUEST'
export const INVENTORY_DETAILS_SUCCESS = 'INVENTORY_DETAILS_SUCCESS'
export const INVENTORY_DETAILS_FAIL = 'INVENTORY_DETAILS_FAIL'
export const INVENTORY_DETAILS_RESET = 'INVENTORY_DETAILS_RESET'

export const MULTI_INVENTORY_UPDATE_REQUEST = 'MULTI_INVENTORY_UPDATE_REQUEST'
export const MULTI_INVENTORY_UPDATE_SUCCESS = 'MULTI_INVENTORY_UPDATE_SUCCESS'
export const MULTI_INVENTORY_UPDATE_FAIL = 'MULTI_INVENTORY_UPDATE_FAIL'
export const MULTI_INVENTORY_UPDATE_RESET = 'MULTI_INVENTORY_UPDATE_RESET'

export const INVENTORY_SUMMARY_REQUEST = 'INVENTORY_SUMMARY_REQUEST'
export const INVENTORY_SUMMARY_SUCCESS = 'INVENTORY_SUMMARY_SUCCESS'
export const INVENTORY_SUMMARY_FAIL = 'INVENTORY_SUMMARY_FAIL'
